import { render } from "./ViewAlaUnePage.vue?vue&type=template&id=34cf5c06&ts=true"
import script from "./ViewAlaUnePage.vue?vue&type=script&lang=ts"
export * from "./ViewAlaUnePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__